var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "page-main" },
    [
      !_vm.$route.params.inner
        ? _c(_vm.pageType, {
            tag: "component",
            attrs: { page: _vm.page, crumbs: _vm.crumbs },
            on: {
              updateItems: function($event) {
                return _vm.$emit("updateItems")
              }
            }
          })
        : _c("nuxt-child", { attrs: { page: _vm.page } }),
      _c("btn-top")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a1cb502", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a1cb502","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageWrap.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6a1cb502","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageWrap.vue
// module chunks = 0